import { useMemo } from 'react';

export interface InputFieldProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  label?: string;
  onChange?: (key: string, value: string | number) => void;
  id?: string;
}

// Calculate tomorrow's date
const getTomorrowDate = () => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() + 1);
  return yesterday.toISOString().split('T')[0];
};

const Input = (props: InputFieldProps) => {
  const {
    label = '',
    className = '',
    onChange,
    id = '',
    ...inputProps
  } = props;

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // check if its a number
    if (!onChange) return;
    onChange(
      id,
      inputProps.type === 'number' ? e.target.valueAsNumber : e.target.value,
    );
  };

  const minDateInput = useMemo(() => {
    return inputProps.type === 'date' ? getTomorrowDate() : undefined;
  }, [inputProps.type]);

  return (
    <div className={className}>
      {label && (
        <label
          className="text-gray-700 mb-0-5 block text-1-6 md:text-1-2"
          htmlFor={label}
        >
          {label} {inputProps.required && '*'}
        </label>
      )}
      <input
        {...inputProps}
        id={label}
        onChange={handleOnChange}
        min={minDateInput}
        className="mb-0 block w-full appearance-none rounded-8-0 border p-1-0 text-body1 leading-1-0 text-grey-800  focus:outline-none read-only:bg-secondary-grey disabled:bg-secondary-grey"
      />
    </div>
  );
};

export default Input;
